export default __webpack_public_path__ + "static/media/baby.06b23687.png";